type ChatwootConfig = {
  baseUrl: string;
  websiteToken: string;
};

type ChatwootWindow = Window & {
  chatwootSDK?: { run: (config: { baseUrl: string; websiteToken: string }) => void };
  chatwootSettings?: {
    hideMessageBubble: boolean;
    locale: string;
    position: 'right';
    type: 'standard';
  };
};

const SCRIPT_ID = 'canabiz-chatwoot-sdk';

const envConfig = (): ChatwootConfig => ({
  baseUrl: import.meta.env.VITE_CHATWOOT_BASE_URL ?? '',
  websiteToken: import.meta.env.VITE_CHATWOOT_WEBSITE_TOKEN ?? '',
});

export const installChatwootWidget = (config: ChatwootConfig = envConfig()): void => {
  const baseUrl = config.baseUrl.replace(/\/$/, '');
  if (!baseUrl || !config.websiteToken || document.getElementById(SCRIPT_ID)) return;

  const chatwootWindow = window as ChatwootWindow;
  chatwootWindow.chatwootSettings = {
    hideMessageBubble: false,
    locale: 'pt_BR',
    position: 'right',
    type: 'standard',
  };

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `${baseUrl}/packs/js/sdk.js`;
  script.onload = () => chatwootWindow.chatwootSDK?.run({ baseUrl, websiteToken: config.websiteToken });
  document.head.appendChild(script);
};
